var _defs, _path, _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 61 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_62);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_53);\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_59);\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_54);\n      }\n\n      .cls-5 {\n        fill: url(#Degradado_sin_nombre_41);\n      }\n\n      .cls-6 {\n        fill: url(#Degradado_sin_nombre_46);\n      }\n\n      .cls-10 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-11 {\n        fill: url(#Degradado_sin_nombre_166);\n        filter: url(#drop-shadow-1);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .cls-7 {\n        fill: url(#Degradado_sin_nombre_54-2);\n      }\n\n      .cls-8 {\n        fill: #4c1e5e;\n      }\n\n      .cls-9 {\n        fill: #ffcd00;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_166",
    "data-name": "Degradado sin nombre 166",
    cx: 30.17,
    cy: 32.93,
    fx: 30.17,
    fy: 32.93,
    r: 13.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.29,
    dy: 8.33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 10.29
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff00cf",
    floodOpacity: 0.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_41",
    "data-name": "Degradado sin nombre 41",
    x1: 26.93,
    y1: 38.83,
    x2: 32.42,
    y2: 28.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#652780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b43372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_59",
    "data-name": "Degradado sin nombre 59",
    x1: 21.19,
    y1: 35.73,
    x2: 26.68,
    y2: 25.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29285b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b43372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_54",
    "data-name": "Degradado sin nombre 54",
    x1: 21.65,
    y1: 35.98,
    x2: 27.13,
    y2: 25.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29285b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b43372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_54-2",
    "data-name": "Degradado sin nombre 54",
    x1: 25.06,
    y1: 37.82,
    x2: 30.54,
    y2: 27.68,
    xlinkHref: "#Degradado_sin_nombre_54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_53",
    "data-name": "Degradado sin nombre 53",
    x1: 30.8,
    y1: 40.92,
    x2: 36.28,
    y2: 30.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29285b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b43372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_46",
    "data-name": "Degradado sin nombre 46",
    x1: 30.35,
    y1: 40.68,
    x2: 35.83,
    y2: 30.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#652780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b43372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_62",
    "data-name": "Degradado sin nombre 62",
    x1: 25.99,
    y1: 38.5,
    x2: 31.47,
    y2: 28.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#29285b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#31275c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#672764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#95266b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#b82570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d12573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#e02576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e62577"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.29,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 10.29
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe000",
    floodOpacity: 0.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m40.44,45.44c0-.64,0-1.24,0-1.84,0-.58.31-.91.81-.91.44,0,.76.34.77.85.01.86.02,1.71,0,2.57-.01.66-.32.92-1,.92-6.35,0-12.7.01-19.05,0-1.54,0-2.7-.75-3.36-2.15-.19-.4-.29-.89-.29-1.34-.02-7.08-.03-14.17,0-21.25,0-1.29.68-2.28,1.81-2.94.64-.38,1.34-.5,2.08-.5,6.25,0,12.51,0,18.76,0,.82,0,1.05.3,1.05,1.05,0,6.82,0,13.64,0,20.46,0,.68-.3.97-.98.97-6.27,0-12.53,0-18.8,0-.57,0-1.11.1-1.59.48-.92.74-1.04,2-.32,2.88.46.55,1.04.77,1.76.77,5.98-.01,11.95,0,17.93,0,.12,0,.24,0,.41,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m37.55,26.72c0,.17-.31.31-.7.31h-6.03c-.38,0-.85.01-1.04.02-.18.01-.49-.16-.3-.49l1.73-2.99c.19-.33.62-.45.96-.26l4.78,2.76c.33.19.61.49.61.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m30.39,22.28c.15.08.11.43-.08.76l-3.01,5.22c-.19.33-.35.61-.35.61,0,0-.07.13-.15.3-.08.16-.39.35-.58.02l-1.73-2.99c-.19-.33-.08-.76.26-.96l4.78-2.76c.33-.19.73-.28.87-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m22.96,26.26c.15-.08.42.12.62.45l3.01,5.22c.19.33.35.61.35.61,0,0,.08.12.19.28.1.15.11.51-.27.51h-3.46c-.38,0-.7-.31-.7-.7v-5.51c0-.38.12-.77.27-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m22.69,34.68c0-.17.31-.31.7-.31h6.03c.38,0,.7,0,.7,0h.34c.35-.07.49.14.3.47l-1.73,3c-.19.33-.62.45-.96.26l-4.78-2.76c-.33-.19-.61-.49-.61-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29.85,39.13c-.15-.08-.11-.43.08-.76l3.01-5.22c.19-.33.35-.61.35-.61,0,0,.07-.13.15-.3.08-.16.39-.35.58-.02l1.73,2.99c.19.33.08.76-.26.96l-4.78,2.76c-.33.19-.73.28-.87.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m37.28,35.15c-.15.08-.42-.12-.62-.45l-3.01-5.22c-.19-.33-.35-.61-.35-.61,0,0-.08-.12-.19-.28-.1-.15-.11-.51.27-.51h3.46c.38,0,.7.31.7.7v5.51c0,.38-.12.77-.27.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.12,28.26c-1.45,0-2.62,1.18-2.62,2.62s1.18,2.62,2.62,2.62h0c.41,0,.8-.09,1.14-.26-.58-.08-1.03-.57-1.03-1.18,0-.66.53-1.19,1.19-1.19.56,0,1.04.39,1.16.92.11-.29.17-.6.17-.92,0-1.45-1.18-2.62-2.62-2.62Zm-.99,2.49c-.32,0-.58-.26-.58-.58s.26-.58.58-.58.58.26.58.58-.26.58-.58.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m37.55,26.72c0,.17-.31.31-.7.31h-6.03c-.38,0-.85.01-1.04.02-.18.01-.49-.16-.3-.49l1.73-2.99c.19-.33.62-.45.96-.26l4.78,2.76c.33.19.61.49.61.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m30.39,22.28c.15.08.11.43-.08.76l-3.01,5.22c-.19.33-.35.61-.35.61,0,0-.07.13-.15.3-.08.16-.39.35-.58.02l-1.73-2.99c-.19-.33-.08-.76.26-.96l4.78-2.76c.33-.19.73-.28.87-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m22.96,26.26c.15-.08.42.12.62.45l3.01,5.22c.19.33.35.61.35.61,0,0,.08.12.19.28.1.15.11.51-.27.51h-3.46c-.38,0-.7-.31-.7-.7v-5.51c0-.38.12-.77.27-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m22.69,34.68c0-.17.31-.31.7-.31h6.03c.38,0,.7,0,.7,0h.34c.35-.07.49.14.3.47l-1.73,3c-.19.33-.62.45-.96.26l-4.78-2.76c-.33-.19-.61-.49-.61-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m29.85,39.13c-.15-.08-.11-.43.08-.76l3.01-5.22c.19-.33.35-.61.35-.61,0,0,.07-.13.15-.3.08-.16.39-.35.58-.02l1.73,2.99c.19.33.08.76-.26.96l-4.78,2.76c-.33.19-.73.28-.87.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m37.28,35.15c-.15.08-.42-.12-.62-.45l-3.01-5.22c-.19-.33-.35-.61-.35-.61,0,0-.08-.12-.19-.28-.1-.15-.11-.51.27-.51h3.46c.38,0,.7.31.7.7v5.51c0,.38-.12.77-.27.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m30.12,28.26c-1.45,0-2.62,1.18-2.62,2.62s1.18,2.62,2.62,2.62h0c.41,0,.8-.09,1.14-.26-.58-.08-1.03-.57-1.03-1.18,0-.66.53-1.19,1.19-1.19.56,0,1.04.39,1.16.92.11-.29.17-.6.17-.92,0-1.45-1.18-2.62-2.62-2.62Zm-.99,2.49c-.32,0-.58-.26-.58-.58s.26-.58.58-.58.58.26.58.58-.26.58-.58.58Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m10.95,21.81c-1.17,1.12-2.84,1.26-2.84,1.26,0,0,.21-1.67,1.38-2.79,1.17-1.12,2.84-1.26,2.84-1.26,0,0-.21,1.67-1.38,2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m6.59,19.53c-.25,1.59.58,3.05.58,3.05,0,0,1.25-1.13,1.5-2.72.25-1.59-.58-3.05-.58-3.05,0,0-1.25,1.13-1.5,2.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m8.76,28.39c-.85,1.37-2.44,1.93-2.44,1.93,0,0-.21-1.67.65-3.04.85-1.37,2.44-1.93,2.44-1.93,0,0,.21,1.67-.65,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m3.97,27.26c.15,1.61,1.32,2.81,1.32,2.81,0,0,.93-1.4.78-3.01-.15-1.61-1.32-2.81-1.32-2.81,0,0-.93,1.4-.78,3.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m9.07,34.93c-.32,1.58-1.62,2.65-1.62,2.65,0,0-.77-1.49-.45-3.08.32-1.58,1.62-2.65,1.62-2.65,0,0,.77,1.49.45,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m4.18,35.53c.7,1.46,2.22,2.18,2.22,2.18,0,0,.39-1.64-.31-3.09-.7-1.46-2.22-2.18-2.22-2.18,0,0-.39,1.64.31,3.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m11.36,42c.09,1.61-.89,2.98-.89,2.98,0,0-1.13-1.25-1.22-2.86-.09-1.61.89-2.98.89-2.98,0,0,1.13,1.25,1.22,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m6.78,43.83c1.05,1.23,2.7,1.54,2.7,1.54,0,0-.04-1.68-1.09-2.91-1.05-1.23-2.7-1.54-2.7-1.54,0,0,.04,1.68,1.09,2.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m15.82,46.69c.77,1.42.48,3.07.48,3.07,0,0-1.55-.64-2.33-2.06-.77-1.42-.48-3.07-.48-3.07,0,0,1.55.64,2.33,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m12.47,50.31c1.47.66,3.1.23,3.1.23,0,0-.76-1.5-2.23-2.16-1.47-.66-3.1-.23-3.1-.23,0,0,.76,1.5,2.23,2.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m21.6,49.82c1.24,1.03,1.58,2.68,1.58,2.68,0,0-1.68-.02-2.93-1.05-1.24-1.03-1.58-2.68-1.58-2.68,0,0,1.68.02,2.93,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m19.83,54.41c1.61.07,2.97-.93,2.97-.93,0,0-1.26-1.11-2.88-1.18-1.61-.07-2.97.93-2.97.93,0,0,1.26,1.11,2.88,1.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m27.93,51.41c1.45.71,2.17,2.23,2.17,2.23,0,0-1.64.38-3.09-.33-1.45-.71-2.17-2.23-2.17-2.23,0,0,1.64-.38,3.09.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m27.3,56.29c1.58-.31,2.66-1.6,2.66-1.6,0,0-1.49-.78-3.07-.47-1.58.31-2.66,1.6-2.66,1.6,0,0,1.49.78,3.07.47Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m50.05,21.81c1.17,1.12,2.84,1.26,2.84,1.26,0,0-.21-1.67-1.38-2.79-1.17-1.12-2.84-1.26-2.84-1.26,0,0,.21,1.67,1.38,2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m54.41,19.53c.25,1.59-.58,3.05-.58,3.05,0,0-1.25-1.13-1.5-2.72-.25-1.59.58-3.05.58-3.05,0,0,1.25,1.13,1.5,2.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m52.24,28.39c.85,1.37,2.44,1.93,2.44,1.93,0,0,.21-1.67-.65-3.04-.85-1.37-2.44-1.93-2.44-1.93,0,0-.21,1.67.65,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m57.03,27.26c-.15,1.61-1.32,2.81-1.32,2.81,0,0-.93-1.4-.78-3.01.15-1.61,1.32-2.81,1.32-2.81,0,0,.93,1.4.78,3.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m51.93,34.93c.32,1.58,1.62,2.65,1.62,2.65,0,0,.77-1.49.45-3.08-.32-1.58-1.62-2.65-1.62-2.65,0,0-.77,1.49-.45,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m56.82,35.53c-.7,1.46-2.22,2.18-2.22,2.18,0,0-.39-1.64.31-3.09.7-1.46,2.22-2.18,2.22-2.18,0,0,.39,1.64-.31,3.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m49.64,42c-.09,1.61.89,2.98.89,2.98,0,0,1.13-1.25,1.22-2.86.09-1.61-.89-2.98-.89-2.98,0,0-1.13,1.25-1.22,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m54.22,43.83c-1.05,1.23-2.7,1.54-2.7,1.54,0,0,.04-1.68,1.09-2.91,1.05-1.23,2.7-1.54,2.7-1.54,0,0-.04,1.68-1.09,2.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m45.18,46.69c-.77,1.42-.48,3.07-.48,3.07,0,0,1.55-.64,2.33-2.06.77-1.42.48-3.07.48-3.07,0,0-1.55.64-2.33,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m48.53,50.31c-1.47.66-3.1.23-3.1.23,0,0,.76-1.5,2.24-2.16,1.47-.66,3.1-.23,3.1-.23,0,0-.76,1.5-2.23,2.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m39.4,49.82c-1.24,1.03-1.58,2.68-1.58,2.68,0,0,1.68-.02,2.93-1.05,1.24-1.03,1.58-2.68,1.58-2.68,0,0-1.68.02-2.93,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m41.17,54.41c-1.61.07-2.97-.93-2.97-.93,0,0,1.26-1.11,2.88-1.18,1.61-.07,2.97.93,2.97.93,0,0-1.26,1.11-2.88,1.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m34.07,51.41c-1.45.71-2.17,2.23-2.17,2.23,0,0,1.64.38,3.09-.33,1.45-.71,2.17-2.23,2.17-2.23,0,0-1.64-.38-3.09.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m34.7,56.29c-1.58-.31-2.66-1.6-2.66-1.6,0,0,1.49-.78,3.07-.47,1.58.31,2.66,1.6,2.66,1.6,0,0-1.49.78-3.07.47Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m37.7,14.83s-6.66.58-14.34-.01c-.04-.47,0-2.84,0-2.84,7.99.62,14.34.01,14.34.01v2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m37.7,14.92c-.3.03-5.88.64-14.34-.01-.38-.32-.02-.66-.02-.66,7.96.63,14.36.01,14.36.01,0,0,.35.28,0,.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "35.62 12.09 37.66 12.09 38.47 7.2 38.46 7.2 35.62 12.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "34.76 6.32 32.16 12.19 32.16 12.3 35.72 12.3 35.72 12.15 34.76 6.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "30.54 6.08 30.53 6.08 28.84 11.92 26.31 6.19 25.36 11.81 22.61 7.06 22.59 7.06 23.39 11.96 25.34 11.96 25.34 12.02 25.34 12.17 28.78 12.18 28.75 12.27 28.69 12.26 28.69 12.3 32.35 12.3 32.35 12.02 30.54 6.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m37.7,12.49c-.3.03-5.88.64-14.34-.01-.38-.32-.02-.66-.02-.66,7.96.63,14.36.01,14.36.01,0,0,.35.28,0,.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m31,6.13c0,.28-.22.5-.5.5s-.5-.22-.5-.5c0-.28.22-.5.5-.5s.5.22.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m35.28,6.5c0,.28-.22.5-.5.5-.28,0-.5-.23-.5-.5,0-.28.23-.5.5-.5s.5.22.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m38.95,7.35c0,.28-.22.5-.5.5-.28,0-.5-.23-.5-.5,0-.28.22-.5.5-.5.28,0,.5.22.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m26.72,6.25c0,.28-.23.5-.5.5s-.5-.22-.5-.5c0-.28.22-.5.5-.5.28,0,.5.22.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m23.05,7.11c0,.28-.22.5-.5.5-.28,0-.5-.22-.5-.5,0-.28.22-.5.5-.5.28,0,.5.22.5.5Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.bc96dfb2065dbfffb5ed13a20ed61050.svg";
export { ForwardRef as ReactComponent };